import React, { useEffect, useState } from 'react';
import GeneralButton from '../components/helpers/GeneralButton';
import GeneralButtonWithText from '../components/helpers/GeneralButtonWithText';
import GeneralAlertUI from '../components/ui/GeneralAlertUI';
import Tools from '../cvp-webgames-core/Misc/Tools';
import { ScenariosConfig, SingleScenarioConfig } from '../misc/interfaces';
import { getSaveData, mapDivEnterToClick, saveGame, setFocus, setUp508, Windows } from '../misc/tools';
enum MainMenuWindow {
	practiceScenarios,
	testScenarios
}

var alertMsg = '';

const mainMenuLogoId = 'main-menu-logo';
const introductionVideoId = 'introduction-video';
const referenceMaterialsId = 'reference-materials';
const practiceScenariosId = 'practice-scenario-bttn';

const scenariosHeaderId = 'scenarios-header';

const referenceMaterialsHeaderId = 'reference-materials-header';
const referenceMaterialsLastItemId = 'reference-materials-last-item';

const videoWindowHeaderId = 'video-window-header';
const videoWindowLastItemId = 'video-window-last-item';

const goodJobWindowHeaderId = 'good-job-window-header';
const goodJobWindowLastItemId = 'good-job-window-last-item';

enum Window508Type {
	Main,
	MainTestScenarios,
	ReferenceMaterials,
	VideoWindow,
	GoodJobWindow
}

var current508Window = Window508Type.Main;

var windows508Layers: any[] = []
windows508Layers[Window508Type.Main] = {
	objects: [
		introductionVideoId,
		referenceMaterialsId
	]
};

windows508Layers[Window508Type.MainTestScenarios] = {
	objects: [
		introductionVideoId,
		practiceScenariosId
	]
};

windows508Layers[Window508Type.ReferenceMaterials] = {
	objects: [
		referenceMaterialsHeaderId,
		referenceMaterialsLastItemId
	]
};

windows508Layers[Window508Type.VideoWindow] = {
	objects: [
		videoWindowHeaderId,
		videoWindowLastItemId
	]
};

windows508Layers[Window508Type.GoodJobWindow] = {
	objects: [
		goodJobWindowHeaderId,
		goodJobWindowLastItemId
	]
};

const getCurrent508WindowLayer = () => {
	return windows508Layers[current508Window];
}


var refMaterialInfo = [
	{
		previewImg: './assets/images/main-menu/reference-materials/pdf1.jpg',
		title: 'Welcome to the era of universal airway management',
		description: 'The landscape on which airway management is practised is rapidly changing. Anaesthetists are no longer perceived to have sole ownership of the airway.',
		link: 'http://cdn.sabercity.com.s3.amazonaws.com/segs-sharefolder/segs-daarc-calm-medsurg-2022/daarc-pdfs/welcome-to-the-era-of-universal-airway-management.pdf'
	},
	{
		previewImg: './assets/images/main-menu/reference-materials/pdf2.jpg',
		title: 'Vortex Approach to airway management - ANZCA Blue Book 2019',
		description: 'While technical competence and adequate planning are crucial to effective airway management, it is well recognised that even well-prepared airway clinicians can...',
		link: 'http://cdn.sabercity.com.s3.amazonaws.com/segs-sharefolder/segs-daarc-calm-medsurg-2022/daarc-pdfs/vortex-approach-to-airway-management-anzca-blue-book-2019.pdf'
	},
	{
		previewImg: './assets/images/main-menu/reference-materials/pdf3.jpg',
		title: '2022 ASA Practice Guidelines for Management of the Difficult Airway',
		description: 'Practice guidelines are systematically developed recommendations that assist the practitioner and patient in making decisions about health care.',
		link: 'http://cdn.sabercity.com.s3.amazonaws.com/segs-sharefolder/segs-daarc-calm-medsurg-2022/daarc-pdfs/2022-asa-practice-guidelines-for-management-of-the-difficult-airway.pdf'
	},
	{
		previewImg: './assets/images/main-menu/reference-materials/pdf4.jpg',
		title: 'The Vortex',
		description: 'The Vortex, for each lifeline consider manipulations to head and neck, larynx and or device, adjuncts, size/type, suction/O2 flow, muscle tone. Maximum three attempts at each lifeline at least one attempt should be by most experienced clinician.',
		link: 'http://cdn.sabercity.com.s3.amazonaws.com/segs-sharefolder/segs-daarc-calm-medsurg-2022/daarc-pdfs/the-vortex.jpg'
	},
	{
		previewImg: './assets/images/main-menu/reference-materials/pdf5.jpg',
		title: 'Vortex Airway Strategy Tool',
		description: 'Vortex airway strategy tool, prepare intervetions, prevent hypoxia and promote teamwork.',
		link: 'http://cdn.sabercity.com.s3.amazonaws.com/segs-sharefolder/segs-daarc-calm-medsurg-2022/daarc-pdfs/vortex-airway-strategy-tool.jpg'
	},
	{
		previewImg: './assets/images/main-menu/reference-materials/pdf6.jpg',
		title: 'Vortex Green Zone',
		description: 'Green zone, optimise, strategise, mobilise. Considerations for planning in the green zone. Situation, airway, patient and team.',
		link: 'http://cdn.sabercity.com.s3.amazonaws.com/segs-sharefolder/segs-daarc-calm-medsurg-2022/daarc-pdfs/vortez-green-zone.jpg'
	},
	{
		previewImg: './assets/images/main-menu/reference-materials/pdf7.jpg',
		title: 'Versa Care Quick Reference Guide',
		description: 'In this document, there are references to different bed models. To identify your bed model, look at the serial number label. The label is on the right side of the weigh frame, under the patients shoulder. ',
		link: 'http://cdn.sabercity.com.s3.amazonaws.com/segs-sharefolder/segs-daarc-calm-medsurg-2022/daarc-pdfs/versacarequickreferenceguide.pdf'
	},
	{
		previewImg: './assets/images/main-menu/reference-materials/pdf8.jpg',
		title: 'DAARC Quick Tips!',
		description: 'Welcome to DAARC! This document is intended to provide quick tips for you! It talks about scoring and certain actions that need to take place during scenarios.',
		link: 'http://cdn.sabercity.com.s3.amazonaws.com/segs-sharefolder/segs-daarc-calm-medsurg-2022/daarc-pdfs/daarc-tips.pdf'
	}
]

var introVideo = './assets/videos/main-menu/introduction.mp4'
var introVideoCC = './assets/videos/main-menu/introduction.vtt'
var optimalActionsVideo = './assets/videos/main-menu/optimal-clinical-actions.mp4'
var optimalActionsVideoCC = './assets/videos/main-menu/optimal-clinical-actions.vtt'

var init = false;

setUp508(() => getCurrent508WindowLayer())

const MainMenuPage = (props: any) => {
	if (localStorage.getItem('show-nuke-popup')) {
		localStorage.removeItem('saved-game-daarc')
	}

	var saveData = getSaveData();

	var completedAllPracticeScenarios = () => {
		var practiceScenarios = saveData.scenarios.filter(s => !s.isSummative);
		var completedPracticeScenarios = saveData.scenarios.filter(s => !s.isSummative && s.isCompleted && s.score >= 80);
		return practiceScenarios.length === completedPracticeScenarios.length;
	}

	var shouldShowTakeTestButton = () => {
		return completedAllPracticeScenarios();
		// return true;
	};
	
	const [currentWindow, setCurrentWindow] = useState(shouldShowTakeTestButton() && saveData.lastScenarioIndexCompleted  && saveData.scenarios[saveData.lastScenarioIndexCompleted].isSummative ? MainMenuWindow.testScenarios : MainMenuWindow.practiceScenarios);
	const [shouldShowGoodJob, setshouldShowGoodJob] = useState(false);
	const [shouldShowCompletedTest, setshouldShowCompletedTest] = useState(false);
	const [forceUpdate, setForceUpdate] = useState(false);
	const [showReferenceMaterials, setShowReferenceMaterials] = useState(false);
	const [showOptimalClinicalActionsVideo, setShowOptimalClinicalActionsVideo] = useState(false);
	const [showIntroductionVideo, setShowIntroductionVideo] = useState(false);

	var completedAllTestScenarios = () => {
		var completedCounter = 0;
		if (!saveData.selectedSummativeScenarioIndices) {
			return true;
		}
		for (var indx = 0; indx < saveData.selectedSummativeScenarioIndices.length; indx++) {
			var scenario = saveData.scenarios[saveData.selectedSummativeScenarioIndices[indx].scenarioNumber];
			if (scenario.isCompleted && scenario.score >= 80) {
				completedCounter++;
			}
		}
		return completedCounter === saveData.selectedSummativeScenarioIndices.length;
	}

	var selectSummativeScenarios = () => {
		//first slot of summative can only be item at index 7
		var result: SummativeSlot[] = [{
			scenarioNumber: 7,
			slotIndex: 0
		}];

		//second slot of summative can be any items between indices 9 and 10
		result.push({
			scenarioNumber: Tools.randomInteger(9, 10),
			slotIndex: 1
		})

		//third slot of summative can only be any item at any of these indices: 4, 6
		result.push({
			scenarioNumber: Tools.randomInteger(1, 2) === 1 ? 4 : 6,
			slotIndex: 2
		})

		//fourth slot of summative can only be any item at any of these indices: 5, 8
		var choices = Tools.randomInteger(1, 2);

		switch (choices) {
			case 1:
				result.push({
					scenarioNumber: 5,
					slotIndex: 3
				});
				break;
			case 2:
				result.push({
					scenarioNumber: 8,
					slotIndex: 3
				});
				break;
		}

		//randomized selection
		Tools.randomizeItemsInArray(result);
		return result;
	}

	useEffect(() => {
		if(shouldShowGoodJob) {
			init = true;
		}
		if (!init) {
			init = true;
			setFocus(mainMenuLogoId);
		}
	});

	if (!saveData.selectedSummativeScenarioIndices) {
		saveData.selectedSummativeScenarioIndices = selectSummativeScenarios();
		saveData.scenarios[saveData.selectedSummativeScenarioIndices[0].scenarioNumber].isUnlocked = true;
		saveGame(saveData);
	}

	if (!saveData.completedAllPracticeScenarios) {
		if (completedAllPracticeScenarios()) {
			saveData.completedAllPracticeScenarios = true;
			saveGame(saveData);
			alertMsg = 'You have completed the Practice Scenarios and may now proceed to the Test Scenarios! You may replay the Practice Scenarios at any time.';
			current508Window = Window508Type.GoodJobWindow;
			setFocus(goodJobWindowHeaderId)
			
			setshouldShowGoodJob(true);
		}
	}

	// if(!saveData.completedAllTestScenarios) {
	// 	if(completedAllTestScenarios()) {
	// 		saveData.completedAllTestScenarios = true;
	// 		saveGame(saveData);
	// 		alertMsg = 'You have completed the Test Scenarios and the DAARC Game! You may replay the Practice or Test Scenarios at any time.';
	// 		setshouldShowGoodJob(true);
	// 	}
	// }

	if (!shouldShowCompletedTest && currentWindow === MainMenuWindow.testScenarios && completedAllTestScenarios()) {
		setshouldShowCompletedTest(true);
		return;
	}

	var renderScenarios = (scenarios: SingleScenarioConfig[]) => {
		return (
			<div style={{
				position: 'absolute',
				top: '450px',
				left: '179px',
				gridTemplateColumns: 'auto auto auto auto',
				display: 'grid',
				width: '1687px',
				height: '250px'
			}}>
				{scenarios.map((s: SingleScenarioConfig, index: number) => {
					if (index > 3) {
						return (null);
					}
					return (
						<div key={Tools.generateGuid()} style={{ position: 'relative' }}>
							<img style={{
								width: '98%'
							}} src="./assets/images/main-menu/scenario/frame_menu_scenario.png" />
							{s.isUnlocked ? <div>
								<img style={{
									position: 'absolute',
									top: '14px',
									left: '20px',
									width: '90px'
								}} src={"./assets/images/main-menu/scenario/icon_menu_patient_" + (s.isMale ? 'male' : 'female') + ".png"} />
								{s.score >= 80 ? <img style={{
									position: 'absolute',
									top: '4px',
									left: '363px',
									width: '45.5px'
								}} src={"./assets/images/main-menu/scenario/check_menu_scenario.png"} /> : (null)}
								<p style={{
									position: 'absolute',
									top: '80px',
									left: '125px',
									margin: '0px',
									width: '272px',
									fontSize: '15pt'
								}} className="title-font" tabIndex={0} aria-label={'scenario ' + (index + 1) + ' ' + s.patientName + ' ' + (s.isCompleted ? 'completed' : 'not completed')}>{s.patientName}</p>

								<p aria-label={'score ' + s.score.toFixed(0) + '%'} tabIndex={0} style={{
									position: 'absolute',
									top: '130px',
									left: '18px',
									margin: '0px',
									width: '100px'
								}} className="title-font">Score</p>
								<p style={{
									position: 'absolute',
									top: '130px',
									left: '110px',
									margin: '0px',
									width: '100px',
									color: 'black',
									zIndex: 1
								}} className="title-font">{s.score.toFixed(0) + '%'}</p>
								<div style={{
									position: 'absolute',
									top: '123px',
									left: '97px',
									width: '264.5px',
									height: '48px'
								}}>
									<div style={{
										backgroundColor: '#EEC300',
										width: (() => {
											var percentage = s.score;

											if (percentage < 25 && percentage > 9) {
												percentage = 25;
											} else if (percentage < 10) {
												percentage = 20;
											}

											return percentage;
										})() + '%',
										height: '100%'
									}}>

									</div>
									{/* <img style={{
										width: '50%',
										height: '100%'
									}} src={"./assets/images/main-menu/scenario/bar_menu_percentdone.png"}/> */}
								</div>

								<GeneralButtonWithText parameters={{
									text: 'Begin',
									ariaLbl: 'Begin',
									top: '-7px',
									left: '-5px',
									width: '195px',
									srcIdle: "./assets/images/main-menu/scenario/button_menu_begin.png",
									srcHighlight: "./assets/images/main-menu/scenario/button_menu_begin.png",
									customMainStyle: {
										position: 'relative'
									},
									customTextStyle: {
										color: 'black'
									},
									onClicked: () => {
										props.updateWindow(s.scenarioWindow);
									}
								}} />
							</div> : (
								<div>
									<img tabIndex={0} aria-label={'scenario ' + (index + 1) + ' locked'} style={{
										position: 'absolute',
										top: '14px',
										left: '50%',
										width: '70px',
										transform: 'translate(-50%, 0)'
									}} src={"./assets/images/main-menu/scenario/lock.png"} />
								</div>
							)}
						</div>
					);
				})}

				{localStorage.getItem('show-nuke-popup') ? (
					<div style={{
						position: 'fixed',
						top: '50%',
						left: '50%',
						width: '100%',
						height: '100%',
						transform: 'translate(-50%, -50%)',
						zIndex: 100
					}}>
						<GeneralAlertUI id={Tools.generateGuid()} parameters={{
							title: 'Message',
							text: 'Because you failed three test scenarios, you will be required to take the practice scenarios before taking the test scenarios again. We recommend you avail yourself of the DAARC educational materials including videos and podcasts.',
							okButton: {
								title: 'Close',
								onClicked: () => {
									localStorage.removeItem('show-nuke-popup');
									setForceUpdate(!forceUpdate);
								}
							}
						}}></GeneralAlertUI>
					</div>
				) : (null)}
			</div>
		);
	};

	

	var renderPracticeScenarios = () => {
		var scenariosToRender: SingleScenarioConfig[] = saveData.scenarios.filter(s => !s.isSummative);
		// var tmp = scenariosToRender[2];
		// scenariosToRender[2] = scenariosToRender[3];
		// scenariosToRender[3] = tmp;

		return (
			<div style={{
			}}>
				<p aria-label='PRACTICE SCENARIOS' id={scenariosHeaderId} tabIndex={0} style={{
					position: 'absolute',
					top: '262px',
					left: '546px',
					margin: '0',
					width: '941px',
					fontSize: '40px',
					textAlign: 'center'
				}} className="title-font">PRACTICE SCENARIOS</p>

				{renderScenarios(scenariosToRender)}

				<p tabIndex={0} style={{
					position: 'absolute',
					top: '712px',
					left: '182px',
					margin: '0px',
					width: '1672px',
					textAlign: 'center',
					fontSize: '15pt'
				}} className="title-font">Once you have completed each of the four practice scenarios with a score of 80% or better, you may continue to the test scenarios.</p>

				{shouldShowTakeTestButton() ? <div>
					<GeneralButtonWithText parameters={{
						text: 'Take Test',
						top: '760px',
						left: '810px',
						width: '405px',
						srcIdle: "./assets/images/main-menu/button_menu_taketest.png",
						srcHighlight: "./assets/images/main-menu/button_menu_taketest_down.png",
						customTextStyle: {
							left: '130px',
							transform: 'translate(0, -50%)',
							width: '260px',
							fontSize: '40px'
						},
						onClicked: () => {
							current508Window = Window508Type.MainTestScenarios;
							setFocus(scenariosHeaderId);
							setCurrentWindow(MainMenuWindow.testScenarios);
						}
					}} />
					<img style={{
						position: 'absolute',
						top: '744px',
						left: '840px',
						width: '140px'
					}} src="./assets/images/main-menu/icon_menu_test.png" />
				</div> : (null)}


			</div>
		);
	}

	const resetTestData = () => {
		saveData.completedAllTestScenarios = false;

		for (var indx = 0; indx < saveData.scenarios.length; indx++) {
			if (saveData.scenarios[indx].isSummative) {
				saveData.scenarios[indx].isCompleted = false;
				saveData.scenarios[indx].isUnlocked = false;
				saveData.scenarios[indx].score = 0;
			}
		}

		saveData.selectedSummativeScenarioIndices = selectSummativeScenarios();
		saveData.scenarios[saveData.selectedSummativeScenarioIndices[0].scenarioNumber].isUnlocked = true;
		saveGame(saveData);
	};

	var renderTestScenarios = () => {
		var scenariosToRender: SingleScenarioConfig[] = [];
		for (var indx = 0; indx < saveData.selectedSummativeScenarioIndices.length; indx++) {
			scenariosToRender.push(saveData.scenarios[saveData.selectedSummativeScenarioIndices[indx].scenarioNumber])
		}
		scenariosToRender[0].isUnlocked = true;
		return (
			<div style={{
			}}>
				<p id={scenariosHeaderId} tabIndex={0} style={{
					position: 'absolute',
					top: '262px',
					left: '546px',
					margin: '0',
					width: '941px',
					fontSize: '40px',
					textAlign: 'center'
				}} className="title-font">{shouldShowCompletedTest ? 'TEST COMPLETE' : 'TEST SCENARIOS'}</p>
				{shouldShowCompletedTest ? (
					<div>
						<p tabIndex={0} style={{
							position: 'absolute',
							top: '372px',
							left: '546px',
							margin: '0',
							width: '941px',
							fontSize: '130pt',
							textAlign: 'center',
							color: 'lime'
						}} className="title-font">Good Job!</p>
						<p tabIndex={0} style={{
							position: 'absolute',
							top: '612px',
							left: '546px',
							margin: '0',
							width: '941px',
							fontSize: '40px',
							textAlign: 'center'
						}} className="title-font">You have completed each of the four test scenarios with a score of 80% or better.</p>
					</div>) : <div>
					{renderScenarios(scenariosToRender)}

					<p tabIndex={0} style={{
						position: 'absolute',
						top: '712px',
						left: '182px',
						margin: '0px',
						width: '1672px',
						textAlign: 'center',
						fontSize: '15pt'
					}} className="title-font">Complete each of the four test scenarios with a score of 80% or better to finish the game.</p>
				</div>};

				{completedAllTestScenarios() ? <GeneralButtonWithText parameters={{
					text: 'RESET TEST',
					top: '760px',
					left: '810px',
					width: '405px',
					ariaLbl: 'Continue',
					srcIdle: "./assets/images/main-menu/button_menu_taketest.png",
					srcHighlight: "./assets/images/main-menu/button_menu_taketest_down.png",
					customTextStyle: {
						fontSize: '40px'
					},
					onClicked: () => {
						resetTestData();
						setshouldShowCompletedTest(false);
					}
				}} /> : (null)}

			</div>
		);
	}

	var renderSideButtons = () => {
		return (
			<div style={{
				position: 'absolute',
				left: '0',
				top: '0',
				width: '100%',
				height: '100%',
				pointerEvents: 'none',
				zIndex: 100
			}}>
				<GeneralButtonWithText parameters={{
					text: '',
					top: '0',
					left: '0',
					width: '293px',
					ariaLbl: 'introduction video',
					id: introductionVideoId,
					srcIdle: "./assets/images/main-menu/side-buttons/introduction-video.png",
					srcHighlight: "./assets/images/main-menu/side-buttons/introduction-video.png",
					customMainStyle: {
					},
					customTextStyle: {
						color: 'black'
					},
					onClicked: () => {
						current508Window = Window508Type.VideoWindow;
						setFocus(videoWindowHeaderId);
						setShowIntroductionVideo(true)
					}
				}} />

				<GeneralButtonWithText parameters={{
					text: '',
					top: '0',
					left: (1920 - 293) + 'px',
					width: '293px',
					ariaLbl: 'optimal clinical actions video',
					srcIdle: "./assets/images/main-menu/side-buttons/optimal-clinical.png",
					srcHighlight: "./assets/images/main-menu/side-buttons/optimal-clinical.png",
					customMainStyle: {
					},
					customTextStyle: {
						color: 'black'
					},
					onClicked: () => {
						current508Window = Window508Type.VideoWindow;
						setFocus(videoWindowHeaderId);
						setShowOptimalClinicalActionsVideo(true)
					}
				}} />
			</div>
		);
	}

	var renderReferenceMaterials = () => {
		return (
			<div style={{
				position: 'absolute',
				left: '0',
				top: '0',
				width: '100%',
				height: '100%',
				pointerEvents: 'all',
				zIndex: 1000,
				backgroundColor: 'rgba(0,0,0, 0.5)'
			}}>
				<div style={{
					position: 'absolute',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					width: '800px',
					height: '640px'
				}}>
					<img style={{
						width: '100%',
						height: '70px'
					}} src="./assets/images/SBAR/header_modal_1.png" />
					<div style={{
						position: 'absolute',
						top: '01px',
						left: '3px',
						width: '733px',
						height: '65px',
					}}>
						<p id={referenceMaterialsHeaderId} tabIndex={0} style={{
							margin: '0px',
							fontSize: '25pt',
							textAlign: 'center',
							position: 'relative',
							top: '13px'
						}} className="title-font">Reference Materials</p>
					</div>
					<GeneralButton parameters={{
						top: '0',
						left: '729px',
						width: '90px',
						ariaLbl: 'Close',
						srcIdle: "./assets/images/general/buttons/button_close_window_main.png",
						srcHighlight: "./assets/images/general/buttons/button_close_window_down.png",
						srcDisabled: null,
						highlightOnHover: false,
						onClicked: () => {
							current508Window = currentWindow === MainMenuWindow.testScenarios ? Window508Type.MainTestScenarios : Window508Type.Main;
							setFocus(mainMenuLogoId);
							setShowReferenceMaterials(false);
						}
					}} />
					<div style={{
						width: '100%',
						height: '570px',
						position: 'absolute',
						top: '70px',
						left: '0'
					}}>
						<img style={{
							width: '100%',
							height: '100%'
						}} src="./assets/images/SBAR/window_modal_1_edited.png" />
						<div style={{
							margin: '20px',
							overflow: 'auto',
							position: 'absolute',
							left: '0',
							top: '0',
							width: '95%',
							height: '540px'
						}}>
							{refMaterialInfo.map((info: any, index: number) => {
								return (
									<div style={{
										position: 'relative',
										width: '100%',
										height: '260px'
									}}>
										<div style={{
											width: '50%',
											position: 'absolute',
											left: '0'
										}}>
											<img src={info.previewImg} alt="" />
										</div>
										<div style={{
											width: '49%',
											position: 'absolute',
											right: '0'
										}}>
											<p tabIndex={0} className='title-font' style={{
												textAlign: 'left',
												margin: '0',
												fontSize: '16pt',
												fontWeight: 'normal'
											}}>{info.title}</p>
											<br />

											<p tabIndex={0} className='title-font' style={{
												textAlign: 'left',
												margin: '0',
												fontSize: '13pt',
												fontWeight: 'normal'
											}}>{info.description}</p>
											<br />
											<div tabIndex={0} id={index === refMaterialInfo.length - 1 ? referenceMaterialsLastItemId : null} onKeyUp={mapDivEnterToClick} onClick={() => {
												document.getElementById('tap-top-open-' + index).click();
											}} style={{
												cursor: 'pointer'
											}}>
												<a id={'tap-top-open-' + index} tabIndex={-1} style={{
													pointerEvents: 'none'
												}} aria-label='Tap to open PDF here' href={info.link} target="_blank">
													<p className='title-font' style={{
														textAlign: 'left',
														margin: '0',
														fontSize: '13pt',
														fontWeight: 'normal'
												}}>Tap to open PDF here</p></a>
											</div>
											
										</div>
									</div>
								)
							})}
						</div>
					</div>

				</div>
			</div>
		);
	}

	var renderVideo = (title: string, url: string, ccUrl: string) => {
		return (
			<div style={{
				position: 'absolute',
				left: '0',
				top: '0',
				width: '100%',
				height: '100%',
				pointerEvents: 'all',
				zIndex: 1000,
				backgroundColor: 'rgba(0,0,0, 0.5)'
			}}>
				<div style={{
					position: 'absolute',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					width: '800px',
					height: '640px'
				}}>
					<img style={{
						width: '100%',
						height: '70px'
					}} src="./assets/images/SBAR/header_modal_1.png" />
					<div style={{
						position: 'absolute',
						top: '01px',
						left: '3px',
						width: '733px',
						height: '65px',
					}}>
						<p id={videoWindowHeaderId} tabIndex={0} style={{
							margin: '0px',
							fontSize: '25pt',
							textAlign: 'center',
							position: 'relative',
							top: '13px'
						}} className="title-font">{title}</p>
					</div>
					<GeneralButton parameters={{
						top: '0',
						left: '729px',
						width: '90px',
						ariaLbl: 'Close',
						srcIdle: "./assets/images/general/buttons/button_close_window_main.png",
						srcHighlight: "./assets/images/general/buttons/button_close_window_down.png",
						srcDisabled: null,
						highlightOnHover: false,
						onClicked: () => {
							current508Window = currentWindow === MainMenuWindow.testScenarios ? Window508Type.MainTestScenarios : Window508Type.Main;
							setFocus(mainMenuLogoId);
							setShowIntroductionVideo(false);
							setShowOptimalClinicalActionsVideo(false);
						}
					}} />
					<div style={{
						width: '100%',
						height: '570px',
						position: 'absolute',
						top: '70px',
						left: '0'
					}}>
						<img style={{
							width: '100%',
							height: '100%'
						}} src="./assets/images/SBAR/window_modal_1_edited.png" />
						<div style={{
							position: 'absolute',
							left: '20PX',
							top: '0',
							width: '95%',
							height: '540px',
						}}>
							<video tabIndex={0} aria-label={'video'} style={{
								width: '100%',
								position: 'absolute',
								left: '50%',
								top: '50%',
								height: '430px',
								transform: 'translate(-50%, -50%)'
							}} controls>
								<source type="video/mp4" src={url} />   
     							<track src={ccUrl} label="English" kind="captions" srcLang="en-us" default ></track>
							</video>
						</div>
					</div>
					<div tabIndex={0} aria-label='end of u i' id={videoWindowLastItemId} style={{
						top: '0',
						left: '0',
						width: '0',
					}}></div>		
				</div>
			</div>
		);
	}

	return (
		<div style={{
			position: 'relative',
			pointerEvents: 'all',
			width: '100%',
			height: '100%'
		}}>

			<img style={{
				position: 'absolute',
				maxWidth: 'none',
				width: '100%'
			}} src="./assets/images/main-menu/background_menu.jpg" />
			{renderSideButtons()}
			{showReferenceMaterials ? renderReferenceMaterials() : (null)}
			{showIntroductionVideo ? renderVideo('Introduction Video', introVideo, introVideoCC) : (null)}
			{showOptimalClinicalActionsVideo ? renderVideo('Optimal Clinical Actions Video', optimalActionsVideo, optimalActionsVideoCC) : (null)}
			<img tabIndex={0} id={mainMenuLogoId} aria-label='Difficult Airway algorithm and rescue cricothyrotomy' style={{
				position: 'absolute',
				maxWidth: 'none',
				width: '1165px',
				left: '50%',
				top: '50px',
				transform: 'translate(-50%, 0)'
			}} src="./assets/images/main-menu/logo_menu.png" />

			<div style={{
				position: 'absolute',
				maxWidth: 'none',
				width: '2049px',
				left: '50%',
				top: '100px',
				transform: 'translate(-50%, 0)'
			}}>
				<img style={{
				}} src="./assets/images/main-menu/window_menu.png" />
				{currentWindow === MainMenuWindow.practiceScenarios ? renderPracticeScenarios() : (null)}
				{currentWindow === MainMenuWindow.testScenarios ? renderTestScenarios() : (null)}

			</div>

			{shouldShowGoodJob ? (
				<div className='modal-bg' style={{
					position: 'absolute',
					left: '0',
					top: '0',
					width: '100%',
					height: '100%'
				}}>
					<div className='center-on-container' style={{
						width: '670px'
					}}>
						<img style={{
						}} src="./assets/images/main-menu/window_modal_2_edited.png" />
						<p id={goodJobWindowHeaderId} tabIndex={0} className='title-font' style={{
							position: 'absolute',
							top: '20px',
							left: 0,
							textAlign: 'center',
							margin: '0',
							width: '100%',
							fontSize: '70pt'
						}}>Good Job!</p>
						<p tabIndex={0} className='title-font' style={{
							position: 'absolute',
							top: '140px',
							left: 0,
							textAlign: 'center',
							margin: '0',
							width: '100%',
							paddingLeft: '10px',
							paddingRight: '10px'
						}}>{alertMsg}</p>

						<img style={{
							position: 'absolute',
							left: '50%',
							top: '260px',
							width: '200px',
							transform: 'translate(-50%, 0)'
						}} src="./assets/images/main-menu/icon_thumbsup.png" />
						<GeneralButtonWithText parameters={{
							text: 'CONTINUE',
							top: '-157px',
							left: '235px',
							width: '195px',
							srcIdle: "./assets/images/main-menu/button_menu_exit.png",
							id: goodJobWindowLastItemId,
							srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
							customMainStyle: {
								position: 'relative',
							},
							customButtonStyle: {
								width: '100%'
							},
							customImgStyle: {
								width: '100%'
							},
							customTextStyle: {
							},
							onClicked: () => {
								current508Window = Window508Type.Main;
								setFocus(mainMenuLogoId);
								setshouldShowGoodJob(false);
							}
						}} />
					</div>

				</div>
			) : (null)}
			<GeneralButtonWithText parameters={{
				text: '',
				top: (1080 - 85) + 'px',
				left: '0',
				width: '293px',
				ariaLbl: 'reference materials',
				id: referenceMaterialsId,
				srcIdle: "./assets/images/main-menu/side-buttons/reference-materials.png",
				srcHighlight: "./assets/images/main-menu/side-buttons/reference-materials.png",
				customMainStyle: {
				},
				customTextStyle: {
					color: 'black'
				},
				onClicked: () => {
					current508Window = Window508Type.ReferenceMaterials;
					setFocus(referenceMaterialsHeaderId);
					setShowReferenceMaterials(true);
				}
			}} />
			{currentWindow === MainMenuWindow.testScenarios ? <GeneralButtonWithText parameters={{
				text: 'Practice Scenarios',
				id: practiceScenariosId,
				top: '950px',
				left: '1692px',
				width: '195px',
				ariaLbl: 'Practice Scenarios',
				srcIdle: "./assets/images/main-menu/button_menu_exit.png",
				srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
				customMainStyle: {
					position: 'relative',
				},
				customButtonStyle: {
					width: '100%'
				},
				customImgStyle: {
					width: '100%'
				},
				customTextStyle: {
				},
				onClicked: () => {
					current508Window = Window508Type.Main;
					setFocus(scenariosHeaderId);
					setCurrentWindow(MainMenuWindow.practiceScenarios);
				}
			}} /> : (null)}
		</div>
	);
};

export interface SummativeSlot {
	slotIndex: number;
	scenarioNumber: number;
}

export default MainMenuPage;
